import { Badge } from "@/components/ui/badge";
import type { BadgeProps } from "@/components/ui/badge";

interface StatusFlagProps {
  label: string;
  variant?: BadgeProps["variant"];
  active?: boolean;
}

export function StatusFlag({ label, variant = "outline", active }: StatusFlagProps) {
  return (
    <Badge variant={variant} className="gap-1.5 font-mono text-[11px]">
      <span
        className={`size-1.5 rounded-full ${active === false ? "bg-muted-foreground" : "bg-current"}`}
        aria-hidden
      />
      {label}
    </Badge>
  );
}
